'use client';

import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import Link from 'next/link';
import { signOut, useSession } from 'next-auth/react';
import React, { useEffect, useState } from 'react';

import DesktopNavbar from '@/components/navbar/desktop';
import MobileNavbar from '@/components/navbar/mobile';

import SignInOrRegisterModal from '../modals/SignInOrRegisterModal';

const Navbar = () => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    window.addEventListener('resize', handleResize);
    handleResize(); // check initial screen size

    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return <nav>{isMobile ? <MobileNavbar /> : <DesktopNavbar />}</nav>;
};

export default Navbar;
